










import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";
import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import CompanyInforChat from '../../components/templates/CompanyInformation/CompanyInforChat.vue'
import UserDetail from '../../components/templates/CompanyInformation/UserDetail.vue'
import UserEvaluation from '../../components/templates/CompanyInformation/UserEvaluation.vue'
import UserRating from '../../components/templates/CompanyInformation/UserRating.vue'
import Loading from '../../components/molecules/Loading.vue'
export default ({
  setup () {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    onMounted(() => {
      company.getCompanyInfor()
    })
    const loading = computed(() => company.loading)
    return {
      loading
    };
  },
 
  components : {
    CompanyInforChat,
    UserDetail,
    UserEvaluation,
    UserRating,
    Loading
  },
})
